module.exports = __webpack_public_path__ + "static/video_banner-be963690d5b8fa1be96fbdb3176f9712.jpg";